const profile = {
    heading: 'Потребителски Профил',
    text: 'Използвайте за лична готварска книга на база съдържанието на сайта.'
};

const favourites = {
    heading: 'Любими Рецепти',
    text: 'Получавате лесен и бърз достъп до всяка рецепта, обозначена като любима.'
};

const createdRecipes = {
    heading: 'Създадени Рецепти',
    text: 'Получавате лесен и бърз достъп до рецептите, които сте създали.'
};

const comments = {
    heading: 'Коментари',
    text: 'Изкажете впечатлението си, за нещо което сте изпробвали.'
};

export default {
    profile,
    favourites,
    createdRecipes,
    comments,
}